(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // src/js/components/table.js
  var _Table = class {
    static create() {
      const tables = window.Store.app.theBody.querySelectorAll(_Table.param.selector);
      let objects = [];
      if (!tables.length) {
        return null;
      }
      tables.forEach((table) => {
        const obj = new _Table(table);
        obj.init();
        objects.push(obj);
      });
      return objects;
    }
    constructor(table) {
      this.el = table;
      this.container = table.querySelector("[data-table-container]");
      this.rows = table.querySelectorAll("[data-table-row]");
      this.switchBtn = table.querySelector("[data-table-switch]") ?? null;
      this.resetBtn = table.querySelector("[data-table-reset]") ?? null;
    }
    init() {
      const self = this;
      this.el.querySelectorAll("[data-table-row]").forEach((row) => {
        const button = row.querySelector("[data-table-row-visibility]");
        const rowId = row.dataset.tableRow;
        if (button) {
          button.addEventListener("click", () => {
            self.hideRow(rowId);
          });
        }
      });
      if (this.switchBtn) {
        this.switchMetric();
        this.switchBtn.addEventListener("change", this.switchMetric.bind(this));
      }
      if (this.resetBtn) {
        this.resetBtn.addEventListener("click", this.resetTable.bind(this));
      }
      this.update();
    }
    update() {
      window.Store.components.collapse.obj.forEach((collapse) => {
        collapse.update();
      });
      if (this.resetBtn) {
        this.resetBtn.disabled = this.getRowsCount(_Table.param.modifiers.hidden_row) === 0 ? true : false;
      }
      if (this.getRowsCount(_Table.param.modifiers.hidden_row) == this.getRowsCount() - 1) {
        this.container.classList.add(_Table.param.modifiers.has_one_row);
      }
    }
    switchMetric() {
      this.container.classList.toggle("has-imperial", this.switchBtn.checked);
      this.update();
      return this.switchBtn.checked;
    }
    hideRow(rowId) {
      const rowToHide = this.el.querySelector(`[data-table-row="${rowId}"]`);
      const rowToggleCallback = (e) => {
        const timeToWait = parseInt(window.getComputedStyle(rowToHide).getPropertyValue("animation-delay")) * 1e3;
        setTimeout(() => {
          rowToHide.style.display = "none";
          rowToHide.removeEventListener("transitionend", rowToggleCallback);
          this.update();
        }, timeToWait);
      };
      if (rowToHide) {
        rowToHide.addEventListener("transitionend", (e) => {
          if (e.currentTarget !== e.target)
            return null;
          rowToggleCallback(e);
        });
        rowToHide.classList.toggle(_Table.param.modifiers.hidden_row);
      }
    }
    resetTable(event) {
      this.rows.forEach((row) => {
        row.classList.remove(_Table.param.modifiers.hidden_row);
        row.style.removeProperty("display");
      });
      this.container.classList.remove(_Table.param.has_one_row);
      this.update();
    }
    getRowsCount(withClassName) {
      const rowsArray = Array.from(this.rows);
      if (!withClassName) {
        return rowsArray.length;
      }
      return rowsArray.filter((row) => row.classList.contains(withClassName)).length;
    }
  };
  var Table = _Table;
  __publicField(Table, "param", {
    selector: ".js-table",
    modifiers: {
      hidden_row: "is-hidden",
      has_one_row: "has-oneRowLeft"
    }
  });
  function render() {
    window.Store.components.table.obj = Table.create();
  }
  window.Store.components.table.render = render;
})();
